export default "__VITE_ASSET__CIk2d4ty__"